<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br />
    <span>{{ "LBL_CONSULTANDO" | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
      <div class="col-12 md:col-6 lg:col-6">
        <label class="lg:col-3 col-6 md:col-4 control-label">{{ "CONVENIOSPLANESCARGOS.LBL_CODIGOCONVENIO" | translate }}:</label>
        <label class="lg:col-3 col-6 md:col-8"><strong>{{ conveniosPlanPagos.codigo }}</strong></label>
      </div>
      <div class="col-12 md:col-6 lg:col-6">
        <label class="lg:col-3 col-6 md:col-4 control-label">{{ "CONVENIOSPLANESCARGOS.LBL_NOMCONVENIO" | translate }}:</label>
        <label class="lg:col-3 col-6 md:col-8"><strong>{{ conveniosPlanPagos.nombre }}</strong></label>
      </div>
      <div class="col-12 md:col-6 lg:col-6">
        <label class="lg:col-3 col-6 md:col-4 control-label">{{ "CONVENIOSPLANESCARGOS.LBL_DESCRIPCION" | translate }}:</label>
        <label class="lg:col-3 col-6 md:col-8"><strong>{{ conveniosPlanPagos.descripcion }}</strong></label>
      </div>
      <div class="col-12 md:col-6 lg:col-6">
        <label class="lg:col-3 col-6 md:col-4 control-label">{{ "CONVENIOSPLANESCARGOS.LBL_INDICADORHABILITADO" | translate }}:</label>
        <label class="lg:col-3 col-6 md:col-8"><strong>{{conveniosPlanPagos.indicadorHabilitado ? "Activo" : "Inactivo"
          }}</strong></label>
      </div>
  </div>
  <div class="grid form-footer-buttons">
    <div class="form-group col-12">
      <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button" pButton
              (click)="regresar()"></button>
    </div>
  </div>
</div>
